import moment from 'moment';
import queryString from 'qs';

const getOperatorViolationsRequest = (filter) =>
  queryString.stringify({
    sort: 'violationTime.asc',
    ...((filter?.date || filter?.paramsDate) && {
      date: moment(filter.date || filter.paramsDate).format('DD-MM-YYYY'),
    }),
    ...(filter?.operatorId && { operatorId: filter.operatorId }),
  });

export default getOperatorViolationsRequest;
